import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Boolean from './boolean';
import Currency from './currency';
import Area from './area';
import Percent from './percent';
import Text from './text';
import TextArea from './textarea';
import Url from './url';
import UrlCollection from './url_collection';

const componentsByType = {
  boolean: Boolean,
  currency: Currency,
  number: Area,
  percentage: Percent,
  textarea: TextArea,
  url: Url,
  url_collection: UrlCollection,
};

export const CustomFields = ({ category, fields }) => {
  const componentsByName = {};

  for (const name in fields) {
    const field = fields[name];
    if (field.custom && field.category === category) {
      if (field.type === 'date') continue;
      componentsByName[name] = componentsByType[field.type] || Text;
    }
  }

  return (
    <React.Fragment>
      {Object.keys(componentsByName).map((name) => {
        const Component = componentsByName[name];
        return <Component key={name} name={name} />;
      })}
    </React.Fragment>
  );
};

CustomFields.propTypes = {
  category: PropTypes.string,
  fields: PropTypes.objectOf(
    PropTypes.shape({
      category: PropTypes.string,
      type: PropTypes.string,
    }),
  ).isRequired,
};

const mapStateToProps = state => ({
  fields: state.fields,
});

export default connect(mapStateToProps)(CustomFields);
